export const PRICE_MONTHLY = "monthly";
export const PRICE_ANNUALLY = "annually";